module.exports = __webpack_public_path__ + "img/signup-success.fd9922d8.svg";